<template>
  <div class="cat_filter_box flx">
    <div class="inp_wrap">
      <select name="size" v-model="selected_size">
        <option :value="null">Размер</option>
        <option :value="item.id" v-for="item in sizeItems" :key="'size-' + item.id">{{ item.name }}</option>
      </select>
    </div>
    <div class="inp_wrap">
      <select name="color" v-model="selected_color">
        <option :value="null">Цвет</option>
        <option :value="item.id" v-for="item in colorItems" :key="'color-' + item.id">{{ item.name }}</option>
      </select>
    </div>
    <div class="inp_wrap" v-if="isAuth()">
      <select name="price" v-model="selected_price">
        <option :value="null">Цена</option>
        <option :value="item.price_from+'-'+item.price_to" v-for="item in priceItems" :key="'price-' + item.price_from+'-'+item.price_to">{{ item.price_from+'-'+item.price_to }}</option>
      </select>
    </div>
    <div class="inp_wrap">
      <span class="reset_filters" @click="clearFilters">Сбросить фильтры</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryFilter',
  inject: ['isAuth'],
  props: {
    sizeItems: {
      type: Array,
      default: () => {}
    },
    colorItems: {
      type: Array,
      default: () => {}
    },
    priceItems: {
      type: Array,
      default: () => {}
    },
    selectedSize: {
      type: Number,
      default: null
    },
    selectedColor: {
      type: Number,
      default: null
    },
    selectedPriceTo: {
      type: Number,
      default: null
    },
    selectedPriceFrom: {
      type: Number,
      default: null
    }
  },
  computed: {
    selected_size: {
      get () {
        return this.selectedSize
      },
      set (val) {
        this.$emit('update:selectedSize', val ? parseInt(val) : null)
        this.$nextTick(() => {
          this.$emit('change-filter')
        })
      }
    },
    selected_color: {
      get () {
        return this.selectedColor
      },
      set (val) {
        this.$emit('update:selectedColor', val ? parseInt(val) : null)
        this.$nextTick(() => {
          this.$emit('change-filter')
        })
      }
    },
    selected_price: {
      get () {
        if (this.selectedPriceFrom && this.selectedPriceTo) {
          return this.selectedPriceFrom + '-' + this.selectedPriceTo
        }
        return null
      },
      set (val) {
        const values = val
        let value = null
        if (values) {
          value = values.split('-')
          if (value[0]) {
            this.$emit('update:selectedPriceFrom', parseInt(value[0]))
          } else {
            this.$emit('update:selectedPriceFrom', null)
          }
          if (value[1]) {
            this.$emit('update:selectedPriceTo', parseInt(value[1]))
          } else {
            this.$emit('update:selectedPriceTo', null)
          }
        } else {
          this.$emit('update:selectedPriceFrom', null)
          this.$emit('update:selectedPriceTo', null)
        }
        this.$nextTick(() => {
          this.$emit('change-filter')
        })
      }
    }
  },
  methods: {
    clearFilters () {
      this.$emit('clear-filters')
    }
  }
}
</script>

<style scoped>

</style>
